import { useEffect } from "react";

const DEST = "https://ice-rink-bookings.emergent.host/schools/sligo";

/**
 * Hard-redirects the browser to the new public booking site.
 * Uses location.replace so the old URL isn't kept in history,
 * plus a meta refresh fallback for crawlers / no-JS clients.
 */
export default function PublicRedirect() {
  useEffect(() => {
    window.location.replace(DEST);
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", fontFamily: "system-ui, -apple-system, sans-serif" }} data-testid="public-redirect">
      <meta httpEquiv="refresh" content={`0; url=${DEST}`} />
      <noscript>
        <div style={{ textAlign: "center" }}>
          <p>This booking page has moved.</p>
          <p><a href={DEST}>Continue to {DEST}</a></p>
        </div>
      </noscript>
      <div style={{ textAlign: "center", color: "#64748b" }}>
        <p style={{ fontSize: 14, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>Redirecting…</p>
        <p style={{ fontSize: 13 }}>
          If nothing happens, <a href={DEST} style={{ color: "#0ea5e9" }}>click here</a>.
        </p>
      </div>
    </div>
  );
}
